import styled from 'styled-components';
import { InfoButtonStyled } from '../InfoButtonStyled';
export const InfoButtonStyledOVGB = styled(InfoButtonStyled)`
    .InfoButton {
        &:after {
            background-image: url("data:image/svg+xml,%3Csvg data-name='0079_N73InformationXSmall_Solid' xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Cdefs%3E%3CclipPath id='dhoq2sjx4a'%3E%3Cpath data-name='0079_N73InformationXSmall_Solid' style='fill:none' d='M0 0h16v16H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3Cg data-name='Groupe 1223' style='clip-path:url(%23dhoq2sjx4a)'%3E%3Cpath data-name='Tracé 706' d='M9.624 4.906H7.219V3.031h2.405zm0 8.5H7.219V6.484h2.405zM.859 8.438A7.562 7.562 0 1 0 8.421.875 7.562 7.562 0 0 0 .859 8.438z' transform='translate(-.422 -.437)' style='fill:%231d1d1b'/%3E%3C/g%3E%3C/svg%3E");
        }
    }
`;
